import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { bottomSheetOpenCountAtom } from '$business/atoms/bottom-sheet';

/**
 * While `isOpen` is true, registers an open bottom sheet in the shared counter
 * so the Layout locks the background checkout scroll. Prevents scroll-bleed
 * behind mobile bottom sheets (the page used to keep scrolling under the sheet).
 * Decrements on close/unmount, so overlapping sheets stay balanced.
 */
export function useLockBackgroundScroll(isOpen: boolean) {
  const setCount = useSetAtom(bottomSheetOpenCountAtom);
  useEffect(() => {
    if (!isOpen) return;
    setCount((c) => c + 1);
    return () => setCount((c) => Math.max(0, c - 1));
  }, [isOpen, setCount]);
}
